<template>
    <div class=page-description>
        <h1 @click="openPopup" v-html="post.acf.exhibit_title || post.title.rendered"></h1>
        <p v-if="post.acf.exhibit_short_description" v-html="post.acf.exhibit_short_description"></p>
        <span class=read-more @click="openPopup" v-if="post.content.rendered">read more</span>

        <TextPopup v-if="post.content.rendered" :text="post.content.rendered" :isActive="popupActive" @close-popup="closePopup" />
    </div>
</template>
<script>
import TextPopup from '../components/TextPopup.vue';

export default {
    name  : 'PageDescription',
    props : {
        title     : String ,
        text      : String ,
        longText  : String ,
        wp        : Boolean,
        wpContent : Object ,
        post      : Object ,
    },
    data() {
        return {
            popupActive : false,
        }
    },
    methods : {
        openPopup() {
          this.popupActive = true
          this.$emit('open-popup');
        },
        closePopup() {
            this.popupActive = false
            this.$emit('close-popup');
        }
    },
    components : {
        TextPopup,
    },
}
</script>